export default "__VITE_ASSET__BMEp9W80__"